import React from 'react';
import styled from '@emotion/styled';

import { getColor } from './UICommon';

const List = styled.ul`
  font-size: 16px;
  list-style: disc;
  margin: 0;
  margin-bottom: 32px;
  padding: 0;
  padding-left: 18px;
`;

const Item = styled.li`
  &::marker {
    color: ${getColor('YELLOW_100')};
  }
  color: ${getColor('BLACK_80')};
  padding-bottom: 8px;
`;

export const PointList = ({ pointList }: { pointList: string[] }) => {
  return (
    <List>
      {pointList.map((point: string) => (
        <Item key={point}>{point}</Item>
      ))}
    </List>
  );
};
